import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'cualapp:paywall_seen';

/**
 * Modal explicativo del paywall/Célula.
 * Escucha el evento 'cualapp:paywall' disparado por el interceptor de 402.
 * Solo se muestra LA PRIMERA VEZ (persistencia en localStorage).
 * Objetivo P0-5: comunicar con calma antes de que el usuario perciba un cobro sorpresa.
 */
const PaywallExplainerModal = () => {
  const [open, setOpen] = useState(false);
  const [triggerMessage, setTriggerMessage] = useState('');

  useEffect(() => {
    const handler = (e) => {
      const alreadySeen = localStorage.getItem(STORAGE_KEY) === '1';
      if (alreadySeen) return;
      setTriggerMessage(e.detail?.message || '');
      setOpen(true);
    };
    window.addEventListener('cualapp:paywall', handler);
    return () => window.removeEventListener('cualapp:paywall', handler);
  }, []);

  const dismiss = (opt) => {
    localStorage.setItem(STORAGE_KEY, '1');
    setOpen(false);
    if (opt === 'go') {
      // Ya estamos en el modulo celula (redirigido por el interceptor).
      window.dispatchEvent(new CustomEvent('cualapp:navigate', { detail: { module: 'celula' } }));
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" data-testid="paywall-explainer-modal">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden">
        <div className="bg-gradient-to-r from-emerald-500 to-teal-600 px-6 py-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-2xl">🌱</div>
            <div>
              <h3 className="text-white text-lg font-bold leading-tight">Tu Celula es tu pase mensual</h3>
              <p className="text-white/85 text-xs">Un momento antes de continuar</p>
            </div>
          </div>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-gray-700 text-sm leading-relaxed">
            <strong>Explorar CUALAPP es libre.</strong> Puedes moverte por la app, mirar y aprender sin costo.
          </p>
          <p className="text-gray-700 text-sm leading-relaxed">
            Cuando quieras <em>hacer</em> algo dentro del ecosistema (enviar dinero, publicar una oferta, recibir pagos, participar en encuestas), necesitas activar tu <strong>Celula</strong>.
          </p>

          <div className="bg-emerald-50 border-l-4 border-emerald-500 rounded p-3 text-sm text-emerald-900">
            <p className="font-medium mb-1">Piensalo asi:</p>
            <p className="leading-relaxed">Es como un pase mensual de metro: pagas una vez, y puedes usar todo lo que hay adentro durante el mes.</p>
          </div>

          <ul className="text-sm text-gray-600 space-y-1.5 pl-1">
            <li className="flex gap-2"><span className="text-emerald-500 flex-shrink-0">✓</span> Nada se activa automaticamente.</li>
            <li className="flex gap-2"><span className="text-emerald-500 flex-shrink-0">✓</span> Puedes cerrar esta ventana y seguir explorando.</li>
            <li className="flex gap-2"><span className="text-emerald-500 flex-shrink-0">✓</span> Cuando decidas activarla, veras los precios claros antes de pagar.</li>
          </ul>

          {triggerMessage && (
            <p className="text-xs text-gray-400 italic border-t border-gray-100 pt-3">
              (La accion que intentabas: {triggerMessage})
            </p>
          )}
        </div>

        <div className="px-6 py-4 bg-gray-50 flex flex-col sm:flex-row-reverse gap-2">
          <button onClick={() => dismiss('go')} data-testid="paywall-modal-see-celula"
            className="px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium">
            Ver mi Celula
          </button>
          <button onClick={() => dismiss('later')} data-testid="paywall-modal-later"
            className="px-4 py-2 rounded-lg bg-white border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50">
            Seguir explorando
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaywallExplainerModal;
